module.exports = __webpack_public_path__ + "static/img/kcli-pt.d15436a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/kcli-pt.jpg
// module id = lWBx
// module chunks = 0